import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=58e00ccc&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58e00ccc')) {
      api.createRecord('58e00ccc', component.options)
    } else {
      api.reload('58e00ccc', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=58e00ccc&", function () {
      api.rerender('58e00ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2C6swR9VoxwtM/JS/comp/childrenage.vue"
export default component.exports